// Must stay in sync with ChallengeRewardType + REWARD_TYPE_VALUE_MAP in the game backend.

export interface RewardTypeMeta {
  id: string;
  label: string;
  // Number of {{textN}} placeholders the description template must contain for this reward type.
  dynamicValues: number;
  // Short hint about what the placeholders resolve to, shown to the CMS user.
  hint: string;
}

export const REWARD_TYPES: RewardTypeMeta[] = [
  {
    id: "PBF_COINS_SMALL",
    label: "PBF Coins (Small)",
    dynamicValues: 1,
    hint: "{{text1}} = coin amount. e.g. \"You will win {{text1}} coins\".",
  },
  {
    id: "PBF_COINS_MEDIUM",
    label: "PBF Coins (Medium)",
    dynamicValues: 1,
    hint: "{{text1}} = coin amount. e.g. \"You will win {{text1}} coins\".",
  },
  {
    id: "PBF_COINS_LARGE",
    label: "PBF Coins (Large)",
    dynamicValues: 1,
    hint: "{{text1}} = coin amount. e.g. \"You will win {{text1}} coins\".",
  },
  {
    id: "XP",
    label: "XP",
    dynamicValues: 1,
    hint: "{{text1}} = XP amount (in the player's currency). e.g. \"Earn {{text1}} XP\".",
  },
  {
    id: "XP_MULTIPLIER",
    label: "XP Multiplier",
    dynamicValues: 2,
    hint: '{{text1}} = multiplier, {{text2}} = duration (e.g. "0d 4h 0m"). e.g. "Get {{text1}}x XP for {{text2}}".',
  },
  {
    id: "PACK",
    label: "Pack",
    dynamicValues: 0,
    hint: "No placeholders. Each reward pack shows its own summary; this text is the fallback when a pack has none.",
  },
  {
    id: "MYSTERY_PLAYER_CARD",
    label: "Mystery Player Card",
    dynamicValues: 0,
    hint: "No placeholders. Each reward pack shows its own summary; this text is the fallback when a pack has none.",
  },
  {
    id: "NEXT_VAULT_LEVEL",
    label: "Next Vault Level",
    dynamicValues: 0,
    hint: "No placeholders. The description is shown to the player exactly as written.",
  },
  {
    id: "FREE_STORE_PACK",
    label: "Free Store Pack",
    dynamicValues: 0,
    hint: "No placeholders. The description is shown to the player exactly as written.",
  },
  {
    id: "COIN_PRIZE_WHEEL",
    label: "Coin Prize Wheel",
    dynamicValues: 0,
    hint: "No placeholders. The description is shown to the player exactly as written.",
  },
];

export const REWARD_TYPE_LABELS: Record<string, string> = REWARD_TYPES.reduce(
  (acc, rt) => {
    acc[rt.id] = rt.label;
    return acc;
  },
  {} as Record<string, string>,
);

export const getRewardTypeMeta = (id?: string): RewardTypeMeta | undefined =>
  REWARD_TYPES.find((rt) => rt.id === id);
